import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { UserContextProvider } from './contexts/users-context';

import { GoogleOAuthProvider } from '@react-oauth/google';

const clientId = "243524074030-km80nt33k83ki01kgln7jer73a4kbpus.apps.googleusercontent.com"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <UserContextProvider>
      <GoogleOAuthProvider clientId={clientId}>
    <App />
  </GoogleOAuthProvider>
      </UserContextProvider>
    </BrowserRouter>
  </React.StrictMode>
);

